<template>
  <div
    :class="$style.slider"
    @mousedown="handleSliderMouseDown"
  >
    <svg
      :class="$style.icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
    >
      <rect
        width="14"
        height="2"
        x="1"
        y="7"
        fill="#ccc"
        rx="1"
      />
    </svg>
    <input
      :value="value"
      type="range"
      :min="min"
      :max="max"
      :style="rangeStyle"
      :disabled="disabled"
      :class="$style.range"
      title=""
      @input.prevent="handleRangeInput"
    >
    <svg
      :class="$style.icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill="#ccc">
        <rect
          width="2"
          height="14"
          x="7"
          y="1"
          rx="1"
        />
        <rect
          width="14"
          height="2"
          x="1"
          y="7"
          rx="1"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    disabled: Boolean
  },
  emits: ['change', 'slide:start', 'slide:stop'],
  computed: {
    rangeStyle() {
      // Получаем процент в диапазоне от min до max
      const percent = ((this.value - this.min) * 100) / (this.max - this.min);
      return {
        background: `linear-gradient(to right, #22bbd2 ${percent}%, #dbdbdb ${percent}%)`
      };
    }
  },
  methods: {
    handleSliderMouseDown() {
      this.$emit('slide:start');
      document.addEventListener(
        'mouseup',
        () => {
          this.$nextTick(() => {
            this.$emit('slide:stop');
          });
        },
        { once: true }
      );
    },
    handleRangeInput({ target }) {
      let value = Number(target.value);
      if (value < this.min) {
        value = this.min;
        target.value = this.min;
      }
      this.$emit('change', value);
    }
  }
};
</script>

<style lang="less" module>
@import '@less/common/variables.less';

.slider {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 22px;
}

.range {
  @sliderHeight: 6px;
  @thumbSize: 22px;

  width: 100%;
  height: @sliderHeight;
  appearance: none;
  background-color: transparent;
  border-radius: 4px;

  .track() {
    height: @sliderHeight;
  }
  &::-webkit-slider-runnable-track {
    .track();
  }
  &::-moz-range-track {
    .track();
  }

  .thumb() {
    appearance: none;
    width: @thumbSize;
    height: @thumbSize;
    border-radius: 50%;
    box-sizing: border-box;
    background-color: @blueColor;
    margin-top: @sliderHeight / 2 - @thumbSize / 2;
    border: 4px solid @whiteColor;
    cursor: pointer;
    filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.4)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.12));
    transition: background-color 0.3s ease;
  }
  &::-webkit-slider-thumb {
    .thumb();
  }
  &::-moz-range-thumb {
    .thumb();
  }
  &:disabled {
    &::-webkit-slider-thumb {
      background-color: #dbdbdb;
    }
    &::-moz-range-thumb {
      background-color: #dbdbdb;
    }
  }

  &:focus {
    outline: none;
  }
}

.icon {
  width: 18px;
  height: 18px;
}
</style>

<i18n lang="json">{}</i18n>
